// let IP = 'm.aurei.cc'
// let URL = `//${IP}:81/`

// let api = 'admin/'

// let url = URL + api

// url = '/admin'
let IP = 'm.aurei.cc:81'
let URL = null
let imageUrl = 'http://m.aurei.cc:81/images/'

if (process.env.NODE_ENV === 'development') {
  URL = '/admin/'
} else {
  URL = 'http://m.aurei.cc:81/admin/'
}

export default {
  IP,
  url: URL,
  imageUrl
}